import {
  Box,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'

import { ProgramContent } from '@cibo/core'
import { Markdown } from '@cibo/ui'

export const PaymentSchedule = ({ program }: { program: { fields: ProgramContent } }) => {
  if (program.fields.paymentSchedule === undefined) {
    return <Box />
  }
  const {
    paymentSchedule: { title, schedule },
  } = program.fields

  return (
    <Stack spacing={2}>
      <Typography variant="h5" align="left" color="text.secondary">
        {title}
      </Typography>
      <Box>
        <Grid container spacing={2}>
          {schedule.map(({ title, tiers }, index) => (
            <Grid xs={12} md={6} lg={schedule.length % 3 === 0 ? 4 : 3} item key={index}>
              <Paper elevation={0}>
                <Table sx={{ borderRadius: 0.5 }}>
                  <TableHead
                    sx={{
                      borderStartStartRadius: 4,
                      borderStartEndRadius: 4,
                    }}
                  >
                    <TableCell variant="head" align="center" sx={{ color: 'text.secondary', p: 1 }}>
                      <Typography variant="h6">{title}</Typography>
                    </TableCell>
                  </TableHead>
                  <TableBody>
                    {tiers.map((tier, tierIndex) => (
                      <TableRow key={tierIndex}>
                        <TableCell align="center">
                          <Markdown color="text.secondary">{tier}</Markdown>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Stack>
  )
}
